import _omit from 'lodash/omit';
import APPCONFIG from '../../constants/Config';
import { REGISTER_INSTALLATION_TRIGGER } from '../../constants/ActionTypes';

const initialSettings = APPCONFIG.installationTrigger;
const installationTrigger = (state = initialSettings, action) => {
  switch (action.type) {
    // REGISTER
    case REGISTER_INSTALLATION_TRIGGER:
      return {
        ...state,
        list: [...state.list, _omit(action, 'type')],
      };
    default:
      return state;
  }
};

export default installationTrigger;



// WEBPACK FOOTER //
// ./reducers/installation/installationTrigger.js